import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { scrollToId, TikTokIcon, TIKTOK_LINKS } from "@/components/Shared";

export default function Navbar() {
  const { count, setCartOpen } = useCart();

  return (
    <header className="fixed top-4 left-0 right-0 z-50 flex justify-center px-4 pointer-events-none">
      <nav className="pointer-events-auto glass-panel rounded-full flex items-center gap-5 sm:gap-7 pl-5 pr-2.5 py-2.5">
        <a
          data-testid="nav-tiktok-link"
          href={TIKTOK_LINKS[0].url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="TikTok"
          className="text-white/60 hover:text-[#ff1053] transition-colors duration-300"
        >
          <TikTokIcon className="w-4 h-4" />
        </a>

        <button data-testid="nav-home-btn" onClick={() => scrollToId("top")} aria-label="Always and Forever home" className="group">
          <img
            src="/assets/logo-hero.jpg"
            alt="Always & Forever embroidered script logo"
            className="h-9 w-9 rounded-full object-cover ring-1 ring-white/20 transition-transform duration-500 group-hover:rotate-[10deg]"
          />
        </button>

        <div className="hidden sm:flex items-center gap-6 text-[10px] uppercase tracking-[0.22em] text-white/50">
          <button data-testid="nav-collection-link" onClick={() => scrollToId("collection")} className="hover:text-white transition-colors duration-300">Collection</button>
          <button data-testid="nav-varsity-link" onClick={() => scrollToId("varsity")} className="hover:text-white transition-colors duration-300">Varsity</button>
          <button data-testid="nav-craft-link" onClick={() => scrollToId("craft")} className="hover:text-white transition-colors duration-300">Craft</button>
        </div>

        <button
          data-testid="nav-cart-btn"
          onClick={() => setCartOpen(true)}
          className="relative flex items-center gap-2 bg-white text-black rounded-full px-5 py-2 text-[10px] uppercase tracking-[0.2em] font-semibold transition-transform duration-300 hover:scale-105 active:scale-95"
        >
          <ShoppingBag className="w-3.5 h-3.5" />
          Cart
          {count > 0 && (
            <span data-testid="nav-cart-count" className="absolute -top-2 -right-1.5 bg-[#ff1053] text-white text-[10px] w-5 h-5 rounded-full flex items-center justify-center font-semibold">
              {count}
            </span>
          )}
        </button>
      </nav>
    </header>
  );
}
